module.exports = __webpack_public_path__ + "img/c16.c708552d.png";